import { Button } from "@/components/ui/button";

// Thin wrapper to provide a shared "CButton" naming consistent with other Shared components.
// It is intentionally a direct re-export of the project's Button component so it behaves identically.
const CButton = Button;

export default CButton;
export { CButton };
